import ShareAuth from '@link/share/vendors/firebase';
import { auth } from '@link/shibuya-sky/stores';

const shibuyaSkyAuth = new ShareAuth(auth);

export default shibuyaSkyAuth;
